const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": "https://gurukrupawood.com/#organization",

  "name": "Gurukrupa Wood Pvt. Ltd.",

  "url": "https://gurukrupawood.com/",

  "logo": {
    "@type": "ImageObject",
    "url": "https://gurukrupawood.com/logo.png"
  },

  "image": "https://gurukrupawood.com/logo.png",

  "description":
    "Gurukrupa Wood Pvt. Ltd. manufactures wooden pallets, boxes, crates & export packaging solutions for industrial and logistics needs.",

  "telephone": "+919624065081",

  "email": "jignesh@gurukrupawood.com",

  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Survey No. 674/2",
    "addressLocality": "Ajapar - Tappar Road, Vill. Bhimasar, Ta. Anjar",
    "addressRegion": "Gujarat",
    "postalCode": "370201",
    "addressCountry": "IN"
  },

  "sameAs": [
    "https://www.linkedin.com/company/gurukrupa-wood-pvt-ltd/",
    "https://www.facebook.com/people/Gurukrupa-Wood-Pvt-Ltd/61589890865706/"
  ]
};

export default organizationSchema;